module.exports = __webpack_public_path__ + "static/media/6.4d6225c6.jpg";